import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const singIn = createAsyncThunk(
  "client/login-Customer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis//webapp/customers/api/v1/login-Customer`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data?.authToken) {
        localStorage.setItem("authToken", response.data.authToken); // Store token
        const userRowId = response.data.customerRes?.[0]?.ROWID;
        if (userRowId) {
          localStorage.setItem("customerId", userRowId); // Store ROWID
        } else {
          console.error("UserRowId is undefined");
        }
      }

      console.log("Signin API Response:", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);
